// Copyright ©️ 2026 eVolve MEP, LLC

import { useCallback } from 'react';

import {
  useEvolvePost,
  getEntityAttachmentRoute,
  type EvolveApiBody,
  type UploadableEntityAttachmentType,
  type EntityAttachmentId,
} from '@evolvemep/api-ts';

export const useAddWebLinks = <T extends UploadableEntityAttachmentType>(
  entityType: T,
  entityId: EntityAttachmentId<T>,
) => {
  const { apiCall: addLinkApiCall, loading } = useEvolvePost(
    getEntityAttachmentRoute(entityType, entityId, 'webLinkAttachment'),
  );

  const addWebLink = useCallback(
    async (values: { url: string; name?: string }) => {
      const body: EvolveApiBody<
        'POST',
        ReturnType<typeof getEntityAttachmentRoute<UploadableEntityAttachmentType, 'webLinkAttachment'>>
      > = values;
      return addLinkApiCall(
        // @ts-expect-error I can't make this type happy, as the call to `apiCall` is becoming too type-expanded
        body,
      );
    },
    [addLinkApiCall],
  );

  return { addWebLink, saving: loading };
};
